export default __webpack_public_path__ + "static/media/shoewh1.6b7b9ca4.jpg";